import React from "react";
//#region components
import { DashboardButtonGroup, FilterButton, PageLayouts } from "components/common";
import ExportedFilesList from "./listView";
import useExportItemsFilterDefinition from "./forms/useExportItemsFilterDefinition";
//#endregion
//#region types
import { TranslationKeys } from "translations";
import { ExportedFilesFormTypes } from "models/formTypes";
import { useExportItemService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import { WintSuperkollAPIModelCustomFilters, WintSuperkollAPIModelExportItems } from "wint-api-client/dist/types";

const ExportedFilesView: React.FC = () => {
  const exportItemsService = useExportItemService();
  const { filterFormFields, filterQueryStateHandler } = useExportItemsFilterDefinition();

  return (
    <PageLayouts.DashboardLayout<ExportedFilesFormTypes.ExportItemsFilter>
      key={"exportedFilesView"}
      entityKey={`exported-files-view`}
      title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.ExportedFiles)}
      hasPermissions={true}
      topRightButtons={<DashboardButtonGroup buttons={[<FilterButton />]} />}
      filterFields={filterFormFields}
      initialFilter={{ onlyMine: true, state: WintSuperkollAPIModelExportItems.ExportItemState.Done }}
      reportToAPIFilterFormatter={exportItemsService.reportToAPIFilter}
      filterCategory={WintSuperkollAPIModelCustomFilters.FilterCategory.Agreement}
      filterQueryStateHandler={filterQueryStateHandler}
    >
      <ExportedFilesList />
    </PageLayouts.DashboardLayout>
  );
};

export default ExportedFilesView;
